export default class {

	constructor(obj) {
		this.xCoordinate = obj.x_coordinate
		this.yCoordinate = obj.y_coordinate
	}
}



// WEBPACK FOOTER //
// ./src/station/dto/DtoLocalization.js